export default __webpack_public_path__ + "static/media/thomas_home.54839409.JPG";